import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { Link } from 'react-router-dom'
import { AuthForm } from '../../components/AuthForm/AuthForm'
import { DashboardLayout } from '../../components/DashboardLayout/DashboardLayout'
import { ErrorContent } from '../../components/ErrorContent/ErrorContent'
import { Title } from '../../components/Title/Title'
import { ROUTES } from '../../constants/routes'
import { useAuth } from '../../hooks/useAuth'

interface IProps {
  hasLayout?: boolean
}

export const NotFound = ({ hasLayout = true }: IProps): React.ReactElement => {
  const { user } = useAuth()

  if (user && hasLayout) {
    return (
      <>
        <Title value="Page Not Found" />
        <DashboardLayout>
          <ErrorContent style={{ marginTop: '7.5rem' }} />
        </DashboardLayout>
      </>
    )
  }

  if (user) {
    return (
      <>
        <Title value="Page Not Found" />
        <ErrorContent style={{ marginTop: '7.5rem' }} />
      </>
    )
  }

  if (hasLayout) {
    return (
      <>
        <Title value="Page Not Found" />
        <AuthForm hideLogo={true}>
          <ErrorContent size="lg">
            <Link to={ROUTES.LOGIN} className="btn btn-outline-primary">
              <FontAwesomeIcon className="me-2" icon={faArrowLeft} />
              Return to Login
            </Link>
          </ErrorContent>
        </AuthForm>
      </>
    )
  }

  return (
    <>
      <Title value="Page Not Found" />
      <ErrorContent size="lg">
        <Link to={ROUTES.LOGIN} className="btn btn-outline-primary">
          <FontAwesomeIcon className="me-2" icon={faArrowLeft} />
          Return to Login
        </Link>
      </ErrorContent>
    </>
  )
}
